import React from "react";
import {NavDropdown} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {Link, NavLink as Links, useRouteMatch} from "react-router-dom";
import logo from "../../assets/img/logo.svg";
import {lockUser, unlockUser} from "../../redux/actions/Auth.Action";
import ChangeCompany from "./ChangeCompany";
import CustomClock from "./CustomClock";
import Notification from "./Notification";
import UserinfoDropdown from "./UserinfoDropdown";

function Headers(props) {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.Auth.lockScreen);
  const CurrentTable = useSelector((state) => state.Cart.CurrentCart);
  const { url } = useRouteMatch();
  const ToggleSidebar = props.sidebarToggle || "";
  const POS = [
    {
      name: "POS",
      icon: "point_of_sale",
      to: url,
    },
    {
      name: "Transaction",
      icon: "receipt_long",
      to: url + `/Transaction`,
    },
    {
      name: "Booking",
      icon: "book_online",
      to: url + `/POSBooking`,
    },
    {
      name: "Members",
      icon: "people",
      to: url + `/ViewMembers`,
    },
    {
      name: "Report",
      icon: "report",
      to: url + `/Report`,
    },
    {
      name: "Order Status",
      icon: "calendar_view_month",
      to: url + `/ViewOrders`,
    },
  ];

  const Kitchen = [
    {
      name: "Order",
      icon: "list_alt",
      to: url,
    },
    {
      view: <CustomClock />,
    },
    {
      name: "Report",
      icon: "bar_chart",
      to: url + `/Report`,
    },
  ];
  const Bar = [
    {
      name: "Order",
      icon: "list_alt",
      to: url,
    },
    {
      view: <CustomClock />,
    },
    {
      name: "Report",
      icon: "bar_chart",
      to: url + `/Report`,
    },
  ];
  const Cake = [
    {
      name: "Order",
      icon: "list_alt",
      to: url,
    },
    {
      view: <CustomClock />,
    },
    {
      name: "Report",
      icon: "bar_chart",
      to: url + `/Report`,
    },
  ];
  const Waiter = (
    <React.Fragment>
      <nav className="topbar-navigation">
        <ul className="menu">
          <li className="menu-item">
            <Link to={url} className="menu-link">
              <span className="material-icons">deck</span>
              <span className="title">
                {CurrentTable ? CurrentTable.table : ""}
              </span>
            </Link>
          </li>
          {!selector ? (
            <li className="menu-item" onClick={() => dispatch(lockUser())}>
              <span className="menu-link">
                <span className="material-icons">lock</span>
                <span className="title">Lock</span>
              </span>
            </li>
          ) : (
            <li className="menu-item" onClick={() => dispatch(unlockUser())}>
              <span className="menu-link">
                <span className="material-icons">lock_open</span>
                <span className="title">Unlock</span>
              </span>
            </li>
          )}
        </ul>
      </nav>
    </React.Fragment>
  );
  const Dashboard = (
    <React.Fragment>
      <ChangeCompany />
    </React.Fragment>
  );
  let Menus = "";
  const contains = props.Layout;
  switch (contains.toUpperCase().replace(/\s/g, "")) {
    case "POS":
      Menus = POS;
      break;
    case "KITCHEN":
      Menus = Kitchen;
      break;
    case "WAITER":
      Menus = Waiter;
      break;
    case "BAR":
      Menus = Bar;
      break;
    case "DASHBOARD":
      Menus = Dashboard;
      break;
    case "CAKEROOM":
      Menus = Cake;
      break;
    default:
      break;
  }
  return (
    <React.Fragment>
      {/* Topbar */}
      <header
        className={`topbar  ${
          url.toUpperCase() !== "/DASHBOARD" ? "topbar-inverse" : ""
        }`}
        style={{
          position: `${url === "/POS" ? "initial" : "fixed"}`,
        }}
      >
        <div className="topbar-left">
          {url.toUpperCase() !== "/DASHBOARD" ? (
            <>
              <div className="topbar-brand">
                <Links to="/">
                  <img
                    src={logo}
                    alt="Narayani Group | Narayani Concept"
                    width={50}
                    style={{ maxHeight: "80px" }}
                    height="80"
                  />
                </Links>
              </div>
              <h3 className="pl-10 topbar-title">{contains ? contains : ""}</h3>
            </>
          ) : (
            <span
              onClick={ToggleSidebar}
              className="topbar-btn sidebar-toggler material-icons-outlined text-dark fs-40"
            >
              menu
            </span>
          )}
        </div>
        <div className="topbar-center">
          {/* <div className="d-none d-md-block">{Menus}</div> */}
          {Menus.length ? (
            <>
              <nav className="topbar-navigation d-none d-md-block">
                <ul className="menu">
                  {Menus.map((menu, index) => (
                    <li className="menu-item" key={`nav-${index}`}>
                      {!menu.view ? (
                        <Links
                          className="menu-link"
                          activeClassName="active"
                          to={menu.to}
                        >
                          <span className="material-icons">{menu.icon}</span>
                          <span className="title">{menu.name}</span>
                        </Links>
                      ) : (
                        menu.view
                      )}
                    </li>
                  ))}
                </ul>
              </nav>

              <NavDropdown
                className="dropdown d-block d-md-none"
                title={
                  <span className="material-icons-outlined fs-40">apps</span>
                }
              >
                <div class="dropdown-menu dropdown-grid">
                  {Menus.map((menu, index) => (
                    <div key={index}>
                      {!menu.view ? (
                        <Links className="dropdown-item" to={menu.to}>
                          <span className="material-icons fs-50 text-dark i8-icon i8-svg-icon">
                            {menu.icon}
                          </span>
                          <span className="title">{menu.name}</span>
                        </Links>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                </div>
              </NavDropdown>
            </>
          ) : (
            Menus
          )}
        </div>
        <div className="topbar-right">
          <ul className="topbar-btns">
            <li className="dropdown">
              <UserinfoDropdown />
            </li>
            <li className="dropdown">
              <Notification />
            </li>
          </ul>
        </div>
      </header>
      {/* END Topbar */}
    </React.Fragment>
  );
}
export default React.memo(Headers);
